<template>
  <div>
    <div class="pa-md-2">
      <div class="font-weight-bold mb-2">
        Inscription {{ get_course_name(inscription) }}
        <v-chip class="ml-2 text-button" v-if="inscription.transfere == '1'" color="dark-red" variant="elevated"
          elevation="0">Inscription transférée</v-chip>
        <v-chip class="ml-2 text-button" v-if="inscription.supprime == '1'" color="dark-red" variant="elevated"
          elevation="0">Inscription annulée</v-chip>
        <v-chip class="ml-2 text-button" v-if="inscription.bourse_dossards_status == 'PENDING'" color="dark-red"
          variant="elevated" elevation="0">Inscription en vente</v-chip>
      </div>
      <div class="mb-2" v-if="inscription.transfere == '1' || inscription.supprime == '1'">
        <v-alert border="start" border-color="primary-dark" elevation="1" v-if="inscription.transfere == '1'">Vous
          n'avez plus accès à cette inscription car elle a été transférée à un autre participant via le formulaire de
          transfert.</v-alert>
        <v-alert border="start" border-color="primary-dark" elevation="1" v-if="inscription.supprime == '1'">Vous n'avez
          plus accès à cette inscription car elle a été supprimée. Cela peut faire suite à une demande de remboursement
          ou une intervention de l'organisateur.</v-alert>

      </div>

      <div v-else>
        <div class="d-flex align-center flex-wrap mb-2">
          <v-chip variant="elevated" elevation="0" density="compact" class="rounded-0"
            :color="inscription.paye == '1' ? 'green-darken-4' : 'dark-red'"> <v-icon icon="mdi-currency-eur"
              class="mr-2"></v-icon> Payée </v-chip>
          <v-chip variant="elevated" elevation="0" density="compact" class="rounded-0"
            :color="inscription.document_recu == '1' ? 'green-darken-4' : 'dark-red'"> <v-icon
              icon="mdi-file-edit-outline" class="mr-2"></v-icon> Document reçu </v-chip>
          <v-chip variant="elevated" elevation="0" density="compact" class="rounded-0"
            :color="inscription.document_valide == '1' ? 'green-darken-4' : 'dark-red'"> <v-icon
              icon="mdi-file-check-outline" class="mr-2"></v-icon> Document validé </v-chip>
          <v-chip variant="elevated" elevation="0" density="compact" class="rounded-0"
            :color="inscription.valide == '1' ? 'green-darken-4' : 'dark-red'"> <v-icon icon="mdi-check-bold"
              class="mr-2"></v-icon> Validée </v-chip>
        </div>
        <v-alert border="start" class="my-2" border-color="primary-dark" elevation="1"
          v-if="mainStore.module.status == 'apres_fermeture'">Les inscriptions sont closes, vous ne pouvez plus
          modifier cette inscription.</v-alert>
        <v-alert border="start" class="my-2" border-color="primary-dark" elevation="1" v-if="!is_switchable.status">{{
          is_switchable.message }}</v-alert>
        <v-alert border="start" class="my-2" border-color="primary-dark" elevation="1" v-if="!is_transferable.status">{{
          is_transferable.message }}</v-alert>
        <v-alert border="start" class="my-2" border-color="primary-dark" elevation="1" v-if="gia_expired">La date limite
          d'utilisation de la GIA est dépassée. Vous ne pouvez demander le remboursement.</v-alert>

        <v-row no-gutters class="mt-2">
          <v-col cols="12" lg="6" xl="4" v-if="mainStore.module.status != 'apres_fermeture'">
            <div class="d-flex sm-gap flex-wrap bg-white bordered justify-space-between ma-md-1 my-1">
              <div class="px-2 py-1">
                <div>Editer les informations</div>
                <div class="text-subtitle-1">de {{ get_coureur_name(inscription) }}</div>
              </div>
              <div>
                <router-link :to="{ name: 'EditInscription', params: { id_inscription: inscription.id } }"><v-btn
                    color="primary-dark" variant="tonal" elevation="0" block class="h-100 rounded-0"><v-icon
                      icon="mdi-pencil-outline" size="x-large"></v-icon></v-btn></router-link>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" xl="4" v-if="display_document_button">
            <div class="d-flex sm-gap bordered justify-space-between ma-md-1 my-1"
              :class="[inscription.document_recu == '1' ? 'bg-white' : 'bg-red-lighten-5']">
              <div class="px-2 py-1">
                <div>Documents du participant</div>

                <div class="text-subtitle-1" v-if="inscription.document_recu == '1'">Licence/C.M</div>
                <div class="text-subtitle-1 text-dark-red" v-else>Document non reçu</div>
              </div>
              <div>
                <router-link :to="{ name: 'EditDocument', params: { id_inscription: inscription.id } }"
                  v-if="has_document_asked"><v-btn
                    :color="inscription.document_recu == '1' ? 'primary-dark' : 'red-darken-4'" variant="tonal"
                    elevation="0" block class="h-100 rounded-0"><v-icon icon="mdi-file-document-edit-outline"
                      size="x-large"></v-icon></v-btn></router-link>
                <router-link :to="{ name: 'EditInscription', params: { id_inscription: inscription.id } }" v-else><v-btn
                    color="primary-dark" variant="tonal" elevation="0" block class="h-100 rounded-0"><v-icon
                      icon="mdi-pencil-outline" size="x-large"></v-icon></v-btn></router-link>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" xl="4">
            <div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
              <div class="px-2 py-1">
                <div>Renvoyer le mail d'inscription</div>
                <div class="text-subtitle-1">à {{ get_coureur_email(inscription) }}</div>
              </div>
              <div>
                <v-btn color="primary-dark" variant="tonal" elevation="0" block class="h-100 rounded-0"
                  @click="resend_inscription_email()"><v-icon icon="mdi-email-plus-outline"
                    size="x-large"></v-icon></v-btn>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" xl="4">
            <div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
              <div class="px-2 py-1">
                <div>Télécharger le billet</div>
                <div class="text-subtitle-1">en PDF</div>
              </div>
              <div>
                <a :href="base_url + 'billet/get.php?id_inscription=' + inscription.id_crypted" target="_blank"><v-btn
                    color="primary-dark" variant="tonal" elevation="0" block class="h-100 rounded-0 rounded-e"><v-icon
                      icon="mdi-download" size="x-large"></v-icon></v-btn></a>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" xl="4" v-if="is_transferable.status">
            <div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
              <div class="px-2 py-1">
                <div>Transférer mon inscription</div>
                <div class="text-subtitle-1">à un autre participant</div>
              </div>
              <div>
                <router-link
                  :to="{ name: 'RequestTransfertInscription', params: { id_inscription: inscription.id } }"><v-btn
                    color="primary-dark" variant="tonal" elevation="0" block class="h-100 rounded-0"><v-icon
                      icon="mdi-swap-horizontal" size="x-large"></v-icon></v-btn></router-link>
              </div>
            </div>
          </v-col>

          <v-col cols="12" lg="6" xl="4" v-if="is_sellable.status">
            <div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
              <div class="px-2 py-1">
                <div>Vendre mon inscription</div>
                <div class="text-subtitle-1">sur la bourse aux dossards</div>
              </div>
              <div>
                <router-link
                  :to="{ name: 'RequestBourseDossardInscription', params: { id_inscription: inscription.id } }"><v-btn
                    color="primary-dark" variant="tonal" elevation="0" block class="h-100 rounded-0"><v-icon
                      icon="mdi-swap-horizontal" size="x-large"></v-icon></v-btn></router-link>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" xl="4" v-if="is_switchable.status">
            <div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
              <div class="px-2 py-1">
                <div>Changer de parcours</div>
                <div class="text-subtitle-1">pour ce participant</div>
              </div>
              <div>
                <router-link
                  :to="{ name: 'ChangerParcours', params: { id_commande_inscription: inscription.id_commande_inscription } }"><v-btn
                    color="primary-dark" variant="tonal" elevation="0" block class="h-100 rounded-0"><v-icon
                      icon="mdi-routes" size="x-large"></v-icon></v-btn></router-link>
              </div>
            </div>
          </v-col>

          <v-col cols="12" lg="6" xl="4" v-if="gia_available">
            <div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
              <div class="px-2 py-1">
                <div>Demander le remboursement via la GIA</div>
                <div class="text-subtitle-1">pour cette inscription</div>
              </div>
              <div>
                <router-link :to="{ name: 'RefundGIA', params: { id_inscription: inscription.id } }"><v-btn
                    color="primary-dark" variant="tonal" elevation="0" block class="h-100 rounded-0"><v-icon
                      icon="mdi-cash-refund" size="x-large"></v-icon></v-btn></router-link>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-snackbar v-model="display_snackbar">
      {{ text_snackbar }}
      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="display_snackbar = false"> Fermer </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import UserService from "@/services/user.service.js";
export default {
  components: {},
  data() {
    return {
      base_url: process.env.VUE_APP_API_BASE,
      inscription: {},
      display_snackbar: false,
      text_snackbar: "",
    };
  },
  props: ["item", "all_commande_inscription", "gia"],
  computed: {
    ...mapStores(useMainStore),
    display_document_button() {
      const status_module_apres_fermeture = this.mainStore.module.status == "apres_fermeture";
      if (!status_module_apres_fermeture) {
        return true;
      }
      const date_fin_documents = this.mainStore.module.date_fin_documents;
      if (date_fin_documents) {
        const date_fin_documents_endofday = this.$moment(date_fin_documents).endOf("day");
        const now = this.$moment();
        return now.isBefore(date_fin_documents_endofday);
      }
      return false;
    },
    is_switchable() {
      if (this.inscription.inscription_sportive == 0) {
        return { status: false, message: "Le changement de parcours est indisponible pour une inscription non sportive." };
      }
      if (this.mainStore.module.is_complet) {
        return { status: false, message: "Le changement de parcours est indisponible car l'évènement est complet." };
      }
      if (!this.mainStore.module.autoriser_changement_course) {
        return { status: false, message: "Le changement de parcours n'est pas autorisé sur cet évènement." };
      }

      if (this.mainStore.module.has_limite_changement_course && this.$moment(this.mainStore.module.metadatas.limite_changement_course).endOf("day").isBefore(this.$moment())) {
        return { status: false, message: "Le date limite de changement de parcours est dépassée." };
      }
      if (this.all_commande_inscription.inscriptions.length > 1) {
        return { status: false, message: "Le changement de parcours n'est pas autorisé pour les inscriptions à des packs de courses." };
      }
      if (this.inscription.code_reduction != null) {
        return { status: false, message: "Le changement de parcours n'est pas autorisé pour les inscriptions ayant bénéficiée d'une réduction." };
      }
      if (this.inscription.course.type == "relais" || this.inscription.course.type == "duo") {
        return { status: false, message: "Le changement de parcours n'est pas autorisé pour les courses en équipe." };
      }
      if (this.inscription.bourse_dossards_status == 'PENDING') {
        return { status: false, message: "Vous ne pouvez pas changer de parcours car cette inscription est en cours de vente sur la bourse aux dossards." };
      }

      return { status: true, message: "" };
    },
    is_sellable() {
      if (!this.is_transferable.status) {
        return { status: false, message: this.is_transferable.message };
      }
      if (!this.mainStore.module.has_bourse_dossards) {
        return { status: false, message: "La bourse aux dossards n'est pas disponible sur cet évènement." };
      }
      if (this.inscription.bourse_dossards_status == 'PENDING') {
        return { status: false, message: "Cette inscription est déjà en vente sur la bourse aux dossards." };
      }
      return { status: true, message: "" };
    },

    is_transferable() {
      if (this.inscription.course.type == "relais" || this.inscription.course.type == "duo") {
        return { status: false, message: "Le transfert d'inscription n'est pas autorisé pour les courses en équipe." };
      }
      if (this.inscription.from_transfert == 1) {
        return { status: false, message: "Cette inscription provient d'un transfert, vous ne pouvez pas la transférer à nouveau." };
      }
      if (this.inscription.inscription_sportive == 0) {
        return { status: false, message: "Seule les inscriptions sportives peuvent être transferées." };
      }
      if (this.all_commande_inscription.inscriptions.length > 1) {
        return { status: false, message: "Le transfert d'inscription n'est pas autorisé pour les inscriptions à des packs de courses." };
      }
      if (!this.mainStore.module.autoriser_transfert_dossard) {
        return { status: false, message: "Le transfert d'inscription n'est pas autorisé sur cet évènement." };
      }
      if (this.mainStore.module.has_limite_transfert_dossard && this.$moment(this.mainStore.module.metadatas.limite_transfert_dossard).endOf("day").isBefore(this.$moment())) {
        return { status: false, message: "Le date limite de transfert d'inscription est dépassée." };
      }
      if (this.inscription.bourse_dossards_status == 'PENDING') {
        return { status: false, message: "Vous ne pouvez pas transférer cette inscription car elle est en cours de vente sur la bourse aux dossards." };
      }

      return { status: true, message: "" };
    },
    has_document_asked() {
      if (this.inscription.champs["type_document"] !== undefined) {
        return true;
      }
      return false;
    },
    gia_expired() {
      if (!this.gia) {
        return false;
      }
      if (this.inscription.inscription_sportive == 0) {
        return false;
      }
      if (this.inscription.paye == 0) {
        return false;
      }
      if (this.inscription.refunds.length > 0) {
        return false;
      }
      if (this.inscription.supprime == 1) {
        return false;
      }
      if (this.inscription.transfere == 1) {
        return false;
      }
      let date_event = this.$moment(this.mainStore.module.evenement.date_debut);
      let date_now = this.$moment();
      // si 3 jours avant l'évènement
      if (date_now.isAfter(date_event.subtract(3, "days"))) {
        return true;
      }
      return false;
    },
    gia_available() {
      if (!this.gia) {
        return false;
      }
      if (this.inscription.inscription_sportive == 0) {
        return false;
      }
      if (this.inscription.paye == 0) {
        return false;
      }
      if (this.inscription.refunds.length > 0) {
        return false;
      }
      if (this.inscription.supprime == 1) {
        return false;
      }
      if (this.inscription.transfere == 1) {
        return false;
      }
      let date_event = this.$moment(this.mainStore.module.evenement.date_debut);
      let date_now = this.$moment();
      // si 3 jours avant l'évènement
      if (date_now.isAfter(date_event.subtract(3, "days"))) {
        return false;
      }
      return true;
    },
  },
  methods: {
    async resend_inscription_email() {
      let response = await UserService.sendInscriptionEmail(this.inscription.id);
      this.text_snackbar = response;
      this.display_snackbar = true;
    },

    get_coureur_name(inscription) {
      return inscription.nom + " " + inscription.prenom;
    },
    get_coureur_email(inscription) {
      if (inscription.champs.mail && inscription.champs.mail != "") {
        return inscription.champs.mail;
      }
      return this.mainStore.authUser.userMail;
    },
    get_course_name(inscription) {
      if (inscription.inscription_sportive == 1) {
        return inscription.course.nom;
      }
      return " non sportive";
    },
    get_coureur_club(inscription) {
      if (inscription.champs.club && inscription.champs.club != "") {
        return "Club : " + inscription.champs.club;
      }
      return "";
    },
  },
  created() {
    this.inscription = this.item;
  },
};
</script>

<style lang="scss" scoped></style>